import { useMemo } from 'react';
import { useLiveStream } from '@/lib/ws';
import { AdminBackLink } from './AdminPanel';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface BotLogPayload {
  level: 'info' | 'warn' | 'error' | 'debug';
  message: string;
  timestamp: string;
}

export function LogStream() {
  const { messages, connected } = useLiveStream(1000);

  const logs = useMemo(
    () =>
      messages
        .filter((m) => m.channel === 'bot:log')
        .map((m) => m.payload as BotLogPayload),
    [messages]
  );

  return (
    <div className="mx-auto max-w-5xl">
      <AdminBackLink />
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Live Log</h1>
        <span
          className={
            connected
              ? 'rounded-full bg-primary/20 px-2 py-0.5 text-xs text-primary'
              : 'rounded-full bg-destructive/20 px-2 py-0.5 text-xs text-destructive'
          }
        >
          {connected ? 'Verbunden' : 'Getrennt'}
        </span>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Bot-Konsole</CardTitle>
          <CardDescription>
            Live-Stream aller stdout/stderr-Zeilen. Zeigt die letzten 1000 Zeilen.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-[60vh] overflow-y-auto rounded-md bg-black/50 p-3 font-mono text-xs">
            {logs.length === 0 && (
              <div className="text-muted-foreground">
                Keine Log-Zeilen empfangen. Wenn der Bot läuft und Redis funktioniert, sollten hier Events erscheinen.
              </div>
            )}
            {logs.map((log, i) => (
              <div
                key={i}
                className={
                  log.level === 'error'
                    ? 'text-red-400'
                    : log.level === 'warn'
                      ? 'text-yellow-400'
                      : log.level === 'debug'
                        ? 'text-muted-foreground'
                        : 'text-foreground'
                }
              >
                <span className="text-muted-foreground">
                  {new Date(log.timestamp).toLocaleTimeString('de-DE')}
                </span>{' '}
                <span className="uppercase">[{log.level}]</span> {log.message}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
